module.exports = __webpack_public_path__ + "media/images/athletes/2420-38ee3ef083753565db87270d00f511f0.png";